import React from 'react';
import styles from './C_FAQSet.module.css';
import W_FAQBlock from '@/components/W_Wrappers/W_FAQBlock/W_FAQBlock';
import { W_FAQBlockProps } from '@/components/W_Wrappers/W_FAQBlock/W_FAQBlock';

interface C_FAQSetProps {
  items: W_FAQBlockProps[];
}

export default function C_FAQSet({ items }: C_FAQSetProps) {
  return (
    <div className={styles.wrapper}>
      {items.map(item => (
        <W_FAQBlock
          key={item.title}
          title={item.title}
          icon={item.icon}
          items={item.items}
        />
      ))}
    </div>
  );
}
